import { Action } from 'redux';

import { SiteNamesRequest, SitesNamesRequestSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';

// SiteNamesRequestAction

export interface SiteNamesRequestAction extends Action {}

export function siteNamesRequest(): SiteNamesRequestAction {
  return {
    type: SiteNamesRequest
  };
}

export const isSiteNamesRequestAction = isActionFactory<SiteNamesRequestAction>(SiteNamesRequest);

// SitesNamesRequestSucceededAction

export interface SitesNamesRequestSucceededAction extends Action {
  readonly sites: ReadonlyArray<ISiteNameSansId>;
}

export function siteNamesRequestSucceeded(sites: ReadonlyArray<ISiteNameSansId>): SitesNamesRequestSucceededAction {
  return {
    type: SitesNamesRequestSucceeded,
    sites: sites
  };
}

export const isSiteNamesRequestSucceededAction = isActionFactory<SitesNamesRequestSucceededAction>(SitesNamesRequestSucceeded);
